var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',{attrs:{"dir":"ltr"}},[_vm._v(" "+_vm._s(_vm.humanizedDate)+" - "+_vm._s(_vm.time)+" ")]):_c('span',[_vm._v(" - ")])
}
var staticRenderFns = []

export { render, staticRenderFns }